import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State';

interface UserPreferenceState {
    timestamp: number;
    result: unknown;
}

export type UserPreferencesState = { [key: string]: UserPreferenceState };

export const initialUserPreferencesState: UserPreferencesState = {};

const userPreferencesStateSlice = createSlice({
    name: 'userPreferencesState',
    initialState: initialUserPreferencesState,
    reducers: {
        setPreference: (
            state,
            action: PayloadAction<{
                key: string;
                setting: unknown | undefined;
            }>
        ) => {
            const { key, setting } = action.payload;
            state[key] = {
                timestamp: new Date().getTime(),
                result: setting,
            };
        },
        savedPreference: (
            _state,
            _action: PayloadAction<{
                key: string;
                setting: unknown | undefined;
            }>
        ) => {
            // For effects to hook into...
        },
    },
});

export const { savedPreference, setPreference } =
    userPreferencesStateSlice.actions;

const selectUserPreferences = (state: State) => state.userPreferences;

export const selectUserPreference = <T>(state: State, key: string) => {
    const pref = selectUserPreferences(state)[key];
    if (!pref) {
        return undefined;
    }
    return pref.result as T;
};

export default userPreferencesStateSlice.reducer;
